import * as types from '../API/ActionTypes';
import InitialState from './initialState';

export function oilTestReportFilesReducer(state = InitialState.oilTestReportFiles, action)
{
	switch (action.type)
	{
		case types.OIL_TEST_REPORT_FILES:
			return action.oilTestReportFiles;
		case types.UPDATE_OIL_TEST_REPORT_FILES:
			return [action.oilTestReportFile, ...state];
		default:
			return state;
	}
}

export function oilTestReportFilesErrorReducer(state = InitialState.oilTestReportFilesErrorFlag, action)
{
	switch (action.type)
	{
		case types.OIL_TEST_REPORT_FILES_ERROR:
			return action.oilTestReportFilesErrorFlag;
		default:
			return state;
	}
}

export function oilTestReportFilesLoadingReducer(state = InitialState.oilTestReportFilesLoading, action)
{
	switch (action.type)
	{
		case types.OIL_TEST_REPORT_FILES_LOADING:
			return action.oilTestReportFilesLoading;
		default:
			return state;
	}
}

export function uploadOilTestReportDataReducer(state = InitialState.uploadOilTestReportData, action)
{
	switch (action.type)
	{
		case types.UPLOAD_OIL_TEST_REPORT:
			return action.uploadOilTestReportData;
		default:
			return state;
	}
}

export function uploadOilTestReportErrorReducer(state = InitialState.uploadOilTestReportErrorFlag, action)
{
	switch (action.type)
	{
		case types.UPLOAD_OIL_TEST_REPORT_ERROR:
			return action.uploadOilTestReportErrorFlag;
		default:
			return state;
	}
}

export function uploadOilTestReportLoadingReducer(state = InitialState.uploadOilTestReportLoading, action)
{
	switch (action.type)
	{
		case types.UPLOAD_OIL_TEST_REPORT_LOADING:
			return action.uploadOilTestReportLoading;
		default:
			return state;
	}
}
